module.exports = __webpack_public_path__ + "img/selected-born-of-ocean-swell-2.7b2f2117.webp";